/*
 * External dependencies
 */
import React from 'react';
import PropTypes from 'prop-types';
import { StripeProvider, Elements } from 'react-stripe-elements';

/**
 * Internal dependencies
 */
import Form from './form';
import RestartForm from './restart-form';
import AddCardForm from './add-card-form';

/**
 * Component
 */
const StripeForm = ( { restartForm, addCardForm, onSuccess, isOffer, planOption } ) => {
    const isBrowser = typeof window !== 'undefined';

    if ( ! isBrowser ) {
        return null;
    }

    if ( addCardForm ) {
        return (
            <StripeProvider apiKey={ process.env.GATSBY_STRIPE_PUBLIC }>
                <Elements>
                    <AddCardForm onSuccess={ onSuccess } />
                </Elements>
            </StripeProvider>
        );
    }

    return (
        <StripeProvider apiKey={ process.env.GATSBY_STRIPE_PUBLIC }>
            <Elements>
                { restartForm ? <RestartForm onSuccess={ onSuccess } /> : <Form isOffer={ isOffer } planOption={ planOption } /> }
            </Elements>
        </StripeProvider>
    );
};

StripeForm.propTypes = {
    restartForm: PropTypes.bool,
    onSuccess: PropTypes.func,
    isOffer: PropTypes.any,
};

StripeForm.defaultProps = {
    restartForm: false,
    onSuccess: () => null,
    isOffer: false,
};

export default StripeForm;
